import React from 'react';
import BulletedItem from './BulletedItem';

export default function HighlightBulletItem({ dotColor, children }) {
  return (
    <BulletedItem
      as="div"
      className="p-4 rounded-xl bg-slate-50 border border-slate-100 items-center gap-3"
      marker={<span className={`w-2.5 h-2.5 rounded-full shrink-0 ${dotColor}`} />}
    >
      <p className="text-sm font-medium text-slate-700">{children}</p>
    </BulletedItem>
  );
}
